import { useEffect } from 'react'
import { startEmployeeActivity } from './employeeActivity'

export function useEmployeeActivity(user, token) {
    const enabled=Boolean(token && user && !user.must_change_password && ['master','mechanic','master_workshop','ros'].includes(user.role))
    useEffect(()=>{
        if (!enabled) return
        let revoked=false
        return startEmployeeActivity({token,send:async (body,capturedToken)=>{
            if (revoked || localStorage.getItem('token')!==capturedToken) return
            const controller=new AbortController()
            const timeout=window.setTimeout(()=>controller.abort(),10000)
            try {
                const response=await fetch('/api/users/activity',{method:'POST',headers:{Authorization:`Bearer ${capturedToken}`,'Content-Type':'application/json'},body:JSON.stringify(body),keepalive:true,signal:controller.signal})
                if ([401,403].includes(response.status)) revoked=true
            } finally {window.clearTimeout(timeout)}
        }})
    },[enabled,token,user?.id])
}
